var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_404"},[_c('div',{staticClass:"text text-center"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("您要找的資訊已搬遷至新版官網囉!")]),_c('p',{staticClass:"count"},[_vm._v(_vm._s(_vm.countNum)),_c('span',[_vm._v("秒後將自動返回")])])]),_c('img',{staticClass:"d-lg-none",attrs:{"src":_vm.bg404}})])
}
var staticRenderFns = []

export { render, staticRenderFns }